var React = require('react');

function Lines (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 6L36.3333 39.3333L69.6667 6L103 39.3333L136.333 6L169.667 39.3333L203 6","stroke":"#04776A","strokeWidth":"8","key":0}),React.createElement("path",{"d":"M3 46L36.3333 79.3333L69.6667 46L103 79.3333L136.333 46L169.667 79.3333L203 46","stroke":"#04776A","strokeWidth":"8","key":1}),React.createElement("path",{"d":"M3 86L36.3333 119.333L69.6667 86L103 119.333L136.333 86L169.667 119.333L203 86","stroke":"#04776A","strokeWidth":"8","key":2})]);
}

Lines.defaultProps = {"width":"206","height":"125","viewBox":"0 0 206 125","fill":"none"};

module.exports = Lines;

Lines.default = Lines;
